module.exports = __webpack_public_path__ + "static/media/Metro.2c93b35f.mp3";